import { render, staticRenderFns } from "./form-request.vue?vue&type=template&id=0c68dec2&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./form-request.vue?vue&type=script&lang=js"
export * from "./form-request.vue?vue&type=script&lang=js"
import style0 from "./form-request.vue?vue&type=style&index=0&id=0c68dec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c68dec2",
  null
  
)

export default component.exports